import HeroBreadcrumb from "@/components/layout/HeroBreadcrumb";
import { Scale, Gavel } from "lucide-react";

const STRUMENTI = [
  { titolo: "Commissioni di Conciliazione presso Ebit Lazio e EBTL", desc: "Gestiscono controversie di lavoro favorendo accordi tra le parti in tempi brevi." },
  { titolo: "Commissioni di Conciliazione presso l'IAM di Roma", desc: "Organo istituzionale che agevola la definizione extragiudiziale delle controversie individuali di lavoro." },
  { titolo: "Commissioni di Arbitrato presso Ebit Lazio, EBTL e IAM di Roma", desc: "Forniscono una soluzione alternativa al tribunale, con decisioni vincolanti che garantiscono tempi certi e riduzione dei costi per le parti coinvolte." },
];

export default function ContenziosoLavoroPage() {
  return (
    <main id="main-content">
      {/* Hero */}
      <section className="relative h-[280px] md:h-[320px] overflow-hidden">
        <img src="https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1920&q=60&auto=format" alt="Contenzioso lavoro" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(4, 30, 66, 0.82)" }} />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative h-full flex flex-col justify-end pb-10">
          <HeroBreadcrumb />
          <h1 className="text-4xl md:text-5xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] tracking-tight">Contenzioso sul lavoro</h1>
        </div>
      </section>

      {/* Intro */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <p className="text-lg text-[var(--confcom-text-secondary)] leading-relaxed">Le imprese iscritte a Confcommercio Roma possono accedere a servizi di <strong className="text-[var(--confcom-text-primary)]">risoluzione stragiudiziale delle controversie</strong> attraverso commissioni paritetiche dedicate, con l'obiettivo di evitare il contenzioso giudiziario e favorire soluzioni condivise.</p>
            <div className="rounded-2xl overflow-hidden shadow-md">
              <img src="https://images.unsplash.com/photo-1521791136064-7986c2920216?w=900&q=80&auto=format" alt="Conciliazione e arbitrato" className="w-full h-64 object-cover" loading="lazy" />
            </div>
          </div>
        </div>
      </section>

      {/* Strumenti */}
      <section className="py-16 bg-[#EBF5FF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-8">Strumenti di conciliazione e arbitrato</h2>
          <div className="grid md:grid-cols-3 gap-6">
            {STRUMENTI.map((s) => (
              <div key={s.titolo} className="bg-white rounded-xl border border-[var(--confcom-border)] p-6">
                <div className="flex flex-col gap-4">
                  <div className="w-11 h-11 bg-[var(--confcom-bg-blue-light)] rounded-lg flex items-center justify-center shrink-0">
                    <Gavel size={22} className="text-[var(--confcom-blue)]" aria-hidden="true" />
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-2">{s.titolo}</h3>
                    <p className="text-sm text-[var(--confcom-text-secondary)] leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <p className="text-sm text-[var(--confcom-text-secondary)] mt-8">Questi strumenti rappresentano un'opportunità per imprese e lavoratori di risolvere le controversie in modo rapido, equo ed efficace.</p>
        </div>
      </section>

      {/* Per maggiori informazioni */}
      <section className="py-16 relative overflow-hidden">
        <div className="absolute inset-0">
          <img src="/cta-background.jpg" alt="" className="w-full h-full object-cover" aria-hidden="true" />
          <div className="absolute inset-0" style={{ backgroundColor: "rgba(0, 59, 117, 0.88)" }} />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <h2 className="text-3xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] tracking-tight mb-10 text-center">
            Per maggiori informazioni
          </h2>
          <div className="grid md:grid-cols-2 gap-6">

            {/* EBIT Lazio */}
            <div className="bg-white/10 border border-white/20 rounded-xl p-6">
              <h3 className="text-base font-bold text-white font-['Encode_Sans_Semi_Condensed'] mb-4">EBIT Lazio</h3>
              <ul className="space-y-2 mb-6">
                <li className="flex items-start gap-2 text-sm text-white/80">
                  <span className="text-white font-semibold shrink-0">1 —</span>
                  Commissione Conciliazione ed Arbitrato
                </li>
                <li className="flex items-start gap-2 text-sm text-white/80">
                  <span className="text-white font-semibold shrink-0">2 —</span>
                  Commissione Apprendistato
                </li>
              </ul>
              <div className="border-t border-white/20 pt-4">
                <p className="text-xs font-bold uppercase tracking-wide text-white/50 mb-1">Riferimento</p>
                <p className="text-sm font-semibold text-white">Maria Elisabetta Russo</p>
                <div className="flex flex-col gap-0.5 mt-1">
                  <a href="tel:0668437333" className="text-sm text-[#56B7E6] hover:underline">0668437333</a>
                  <a href="mailto:me.russo@confcommercioroma.it" className="text-sm text-[#56B7E6] hover:underline">me.russo@confcommercioroma.it</a>
                </div>
              </div>
            </div>

            {/* EBTL + IAM */}
            <div className="bg-white/10 border border-white/20 rounded-xl p-6">
              <ul className="space-y-4 mb-6">
                <li className="text-sm text-white/80 leading-snug">
                  <strong className="text-white">EBTL</strong> | Commissione Paritetica Territoriale di Conciliazione delle vertenze individuali
                </li>
                <li className="text-sm text-white/80 leading-snug">
                  <strong className="text-white">IAM (Ispettorato Area Metropolitana Roma)</strong> | Commissione Provinciale di Conciliazione dell'Area Metropolitana di Roma
                </li>
              </ul>
              <div className="border-t border-white/20 pt-4 grid sm:grid-cols-2 gap-4">
                <div>
                  <p className="text-xs font-bold uppercase tracking-wide text-white/50 mb-1">Riferimento</p>
                  <p className="text-sm font-semibold text-white">Dante Cucchi</p>
                  <div className="flex flex-col gap-0.5 mt-1">
                    <a href="tel:0668437334" className="text-sm text-[#56B7E6] hover:underline">0668437334</a>
                    <a href="mailto:d.cucchi@confcommercioroma.it" className="text-sm text-[#56B7E6] hover:underline">d.cucchi@confcommercioroma.it</a>
                  </div>
                </div>
                <div>
                  <p className="text-xs font-bold uppercase tracking-wide text-white/50 mb-1">Riferimento</p>
                  <p className="text-sm font-semibold text-white">Marco Caranzetti</p>
                  <div className="flex flex-col gap-0.5 mt-1">
                    <a href="tel:0668437290" className="text-sm text-[#56B7E6] hover:underline">0668437290</a>
                    <a href="mailto:m.caranzetti@confcommercioroma.it" className="text-sm text-[#56B7E6] hover:underline">m.caranzetti@confcommercioroma.it</a>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </main>
  );
}
